import { defineStore } from "pinia";
import { useSettingsComposable } from "./settings";
import { useApplicationSetupComposable } from "./applicationSetup";
import { useQuickshareComposable } from "./quickshare";

export const useSettingsStore = defineStore("settings", () => {
  const settings = useSettingsComposable();
  const applicationSetup = useApplicationSetupComposable({ setTheme: settings.setTheme });
  const quickshare = useQuickshareComposable({ setTheme: settings.setTheme });

  return {
    ...settings,
    ...applicationSetup,
    ...quickshare
  };
});
